import { Chart } from "primereact/chart";

function CustomChart({ chartLabels, chartDetails }) {
  const documentStyle = getComputedStyle(document.documentElement);
  const chartData = {
    labels: chartLabels,
    datasets: [
      {
        data: chartDetails,
        backgroundColor: [
          documentStyle.getPropertyValue("--blue-500"),
          documentStyle.getPropertyValue("--green-500"),
          documentStyle.getPropertyValue("--pink-500"),
          documentStyle.getPropertyValue("--yellow-500"),
          documentStyle.getPropertyValue("--red-500"),
          documentStyle.getPropertyValue("--bluegray-500"),
          documentStyle.getPropertyValue("--orange-500"),
        ],
        hoverBackgroundColor: [
          documentStyle.getPropertyValue("--blue-500"),
          documentStyle.getPropertyValue("--green-500"),
          documentStyle.getPropertyValue("--pink-500"),
          documentStyle.getPropertyValue("--yellow-500"),
          documentStyle.getPropertyValue("--red-500"),
          documentStyle.getPropertyValue("--bluegray-500"),
          documentStyle.getPropertyValue("--orange-500"),
        ],
      },
    ],
  };
  const chartOptions = {
    cutout: "60%",
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        backgroundColor: "#1e293b", // tooltip bg
        titleColor: "#fff", // title color
        bodyColor: "#fff", // text color
        padding: 10,
        displayColors: false, // hide small color box
        callbacks: {
          label: (context) => {
            const total = context.chart._metasets[0].total;
            const value = context.raw; // seconds
            const label = context.label; // "duration<br />time"
            // Split on <br /> and return as array (Chart.js prints each array item in a new line)
            return label.split("<br />");
          },
          title: () => null, // remove default title
        },
      },
    },
  };

  return <Chart type="doughnut" data={chartData} options={chartOptions} className="w-full" />;
}

export default CustomChart;
